import axios from "axios";
import { HOST } from "../../constants";

const requestAlegriia = axios.create({
  baseURL: HOST,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

const fetcherAlegriia = async (
  data:
    | string
    | {
        url: string;
        params?: Record<string, unknown>;
        auth?: string | null;
        headers?: Record<string, unknown>;
      }
) => {
  const url = typeof data === "string" ? data : data.url;
  const token = typeof data === "string" ? undefined : data.auth;
  const params = typeof data === "string" ? undefined : data.params;
  const headers = typeof data === "string" ? undefined : data.headers;
  return await requestAlegriia
    .get(url, {
      params,
      headers: {
        ...(token && { Authorization: token }),
        ...headers,
      },
    })
    .then((res) => res.data);
};

export { requestAlegriia, fetcherAlegriia };
